import type { AccommodationType, AccommodationCategory, AccommodationStatus, Amenity, AmenityCategory } from "@/types/accommodation";
import { createLookupHook } from "./createLookupHook";

export interface AccommodationLookupsResponse {
  success: boolean;
  message: string;
  data: AccommodationLookupsData;
}

export interface AccommodationLookupsData {
  types: AccommodationType[];
  categories: AccommodationCategory[];
  statuses: AccommodationStatus[];
  amenities: Amenity[];
  amenityCategories: AmenityCategory[];
}



export const useAccommodationLookups = createLookupHook<AccommodationLookupsData>(
  "accommodation",
  "/lookups/accommodation",
);
